<h3 i18n>Page not found!</h3>
<button
  matButton="elevated"
  color="primary"
  (click)="router.navigate(['/'])"
  class="app-panel-button"
>
  <span i18n>Go to the Home page</span>
</button>
